import { Chip } from "@mui/material"
import type { FC } from "react"

import { formatDate } from "@/utils/date"

interface ProductInventoryLotExpiresOnCellProps {
  expiresOn?: string | null
}

export const ProductInventoryLotExpiresOnCell: FC<ProductInventoryLotExpiresOnCellProps> = ({ expiresOn }) => {
  if (!expiresOn) return null

  return <Chip className='h-6 rounded bg-tertiary-green-100 text-xs' label={formatDate(expiresOn)} />
}
